<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/landing"
          :class="getRoute() === 'landing' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Home'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-shop text-danger text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item">
        <sidenav-item
          to="/aboutus"
          :class="getRoute() === 'aboutus' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'About Us'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-app text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/advisory"
          :class="getRoute() === 'advisory' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Advisory & BOM'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-atom text-warning text-sm opacity-10"
            ></i>
          </template>
      
          <!-- Submenu hanya akan muncul jika diisi -->
          <template v-slot:submenu>
            <li class="nav-item">
              <router-link to="/tables/overview" class="nav-link">
                Overview
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/tables/details" class="nav-link">
                Details
              </router-link>
            </li>
          </template>
        </sidenav-item>
      </li>
      

      <li class="nav-item">
        <sidenav-item
          to="/platform"
          :class="getRoute() === 'platform' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Platform'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-spaceship text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/solution"
          :class="getRoute() === 'solution' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Solution'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-air-baloon text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/blogs"
          :class="getRoute() === 'blogs' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Blogs'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/contact"
          :class="getRoute() === 'contact' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Contact'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-briefcase-24 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/setting"
          :class="getRoute() === 'setting' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Setting'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-settings text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

    </ul>
  </div>

 
</template>
<script>
export default {
  data() {
    return {
      isOpen: false
    };
  }
}

</script>